const priceDetailsActionTypes = {
  PRICE_DETAILS_REQUEST: 'PRICE_DETAILS_REQUEST',
  PRICE_DETAILS_SUCCESS: 'PRICE_DETAILS_SUCCESS',
  PRICE_DETAILS_FAILURE: 'PRICE_DETAILS_FAILURE',
};

export default priceDetailsActionTypes;